import httpClient from 'Utils/httpClient';

export const UPLOADCARE_PUB_KEY_TOUCHPOINT_IMAGES = '9562118129115052afc2';
export const UPLOADCARE_PUB_KEY_CAMPAIGNS = '6289eb77c5825eacf514';
export const UPLOADCARE_PUB_KEY_CAMPAIGN_THEME_LOGO = '05efafa1ce108a526af6';
export const UPLOADCARE_PUB_KEY_PLAN_SUMMARY = '6cfe3e83896478fc2864';

export const BASE_URL = 'https://upload.uploadcare.com';
const PREVIEW_FILE_URL = 'api/v2/file-preview/uploadcare';
const UPLOAD_URL = `${BASE_URL}/base/`;

const uploadCareHttpClient = httpClient.create({
	baseURL: BASE_URL,
});
const getFileInfo = async (fileId, pubKey = UPLOADCARE_PUB_KEY_TOUCHPOINT_IMAGES) => {
	const cleanId = fileId.replace(/\/-\/.*/, '');
	const { data } = await uploadCareHttpClient.get('/info/', {
		params: {
			pub_key: pubKey,
			file_id: cleanId,
		},
	});
	return data;
};

const uploadFiles = async (name, type, fileBinary) => {
	const formData = new FormData();
	formData.append('files', fileBinary);
	formData.append('name', name);
	formData.append('type', type);
	formData.append('UPLOADCARE_PUB_KEY', UPLOADCARE_PUB_KEY_TOUCHPOINT_IMAGES);
	formData.append('UPLOADCARE_STORE', 'auto');
	const { data } = await uploadCareHttpClient.post('/base/', formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
	return data;
};

const UPLOADCARE_URL = 'https://ucarecdn.com/';

const getFileUrl = fileId => `${UPLOADCARE_URL}${fileId}/`;

const getSecureFileUrl = fileId =>
	`${PREVIEW_FILE_URL}?url=${encodeURIComponent(getFileUrl(fileId))}`;

export const getFileUid = fileUrl => {
	if (fileUrl.includes(UPLOADCARE_URL)) {
		const stdWithoutUrl = fileUrl.replace(UPLOADCARE_URL, '');
		return stdWithoutUrl.substring(0, stdWithoutUrl.indexOf('/')).replace(/\/$/, '');
	}
	return null;
};

const isFileExists = async fileId => {
	try {
		await httpClient.instance.head(getFileUrl(fileId));
		return true;
	} catch (err) {
		return false;
	}
};

export { UPLOAD_URL, getFileInfo, getFileUrl, getSecureFileUrl, uploadFiles, isFileExists };
